<script lang="ts" setup></script>

<template>
  <a href="https://retaintive.ai/privacy" target="_blank" rel="noopener noreferrer">
    <UiButton variant="link" class="px-0 font-normal underline text-muted-foreground">
      Privacy Policy
    </UiButton>
  </a>
</template>

<style scoped></style>
